

const Banner = ({ showBanner, setShowBanner }) => {
  if (!showBanner) {
    return null;
  }

  const handleClose = () => {
    setShowBanner(false);
  };
  return (
    <div className="bg-[#5CAAF0] p-3 text-center relative">
      <div className="flex flex-col justify-center items-center"> {/* Modified this line */}
      //   <p className="text-sm text-white mb-2 text-center "> {/* Modified this line */}
      // xAuthore is undergoing maintenance from 2 November to 3 November 2026. Thank you for your patience and understanding.
      //   </p>
        {/* <p className="text-sm text-white text-left">
          Before exiting a document, please take a moment to let us know its usefulness by clicking "Yes" or "No." buttons at the top of each document. Your feedback is invaluable in helping us optimize the system for you.
        </p> */}
        <button
          className="absolute top-1 right-2 bg-transparent border-none text-white hover:text-gray-100 focus:outline-none text-lg cursor-pointer"
          onClick={handleClose}
        >
          X
        </button>
      </div>
    </div>
  );
};

export default Banner;
